// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("product-portal." + {"548":"3872fcc02a8b1731036e","902":"868f3dfe05316b365ac6"}[chunkId] + ".js");